import { Badge } from '@/shared/components/ui/badge'
import { safeFormatDateTime } from '@/shared/utils/formatDate'
import { formatAmount } from '@/shared/utils/formatAmount'
import type { DeviceRecharge } from '../hooks/useDeviceRecharges'

interface DeviceRechargesTableProps {
  recharges: DeviceRecharge[]
  currencyNameById: Map<number, string>
}

function formatPhone(countryCode: string, phoneNumber: string): string {
  const cc = countryCode?.trim()
  if (!cc) return phoneNumber
  return `+${cc.replace(/^\+/, '')} ${phoneNumber}`
}

/** Historial de recargas a dispositivos/teléfonos: fecha, teléfono, importe, estado. */
export function DeviceRechargesTable({
  recharges,
  currencyNameById,
}: DeviceRechargesTableProps) {
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-line text-left text-xs font-semibold uppercase tracking-wide text-ink-subtle">
            <th className="px-2 py-3">Fecha</th>
            <th className="px-2 py-3">Teléfono</th>
            <th className="px-2 py-3 text-right">Importe</th>
            <th className="px-2 py-3 text-right">Estado</th>
          </tr>
        </thead>
        <tbody>
          {recharges.map((r) => (
            <tr key={r.id} className="border-b border-line last:border-b-0">
              <td className="whitespace-nowrap px-2 py-3 text-ink-muted">
                {safeFormatDateTime(r.createdAt, '—')}
              </td>
              <td className="whitespace-nowrap px-2 py-3 text-ink">
                {formatPhone(r.countryCode, r.phoneNumber)}
              </td>
              <td className="whitespace-nowrap px-2 py-3 text-right font-medium text-ink">
                {formatAmount(r.amount, r.currencyId, currencyNameById)}
              </td>
              <td className="px-2 py-3 text-right">
                <Badge variant={r.isConfirmed ? 'active' : 'pending'}>
                  {r.isConfirmed ? 'Confirmada' : 'Pendiente'}
                </Badge>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
